import newsvg from "./newsvg.svg"
import check from "./check.svg"

export const Open = () => {
  return (
    <>
    <svg width="25" height="17" viewBox="0 0 25 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.8565 10.0666L21.7131 15.4552C21.4685 15.8746 21.1182 16.2225 20.6972 16.4643C20.2763 16.7061 19.7992 16.8334 19.3138 16.8334H1.95421C1.15026 16.8334 0.649349 15.9613 1.05443 15.2668L4.19783 9.87815C4.44246 9.45879 4.79272 9.11087 5.21372 8.86906C5.63471 8.62726 6.11173 8.50002 6.59722 8.50002H23.9568C24.7607 8.50002 25.2616 9.37211 24.8565 10.0666ZM6.59722 7.11113H20.8333V5.0278C20.8333 3.87719 19.9006 2.94446 18.75 2.94446H11.8056L9.02778 0.166687H2.08333C0.932726 0.166687 0 1.09941 0 2.25002V14.318L2.99813 9.17832C3.74193 7.90323 5.12105 7.11113 6.59722 7.11113Z" fill="black"/>
</svg>

    </>
  )
}

export const Leaves = () => {
    return (
      <>
      <img src={newsvg} style={{backgroundColor:"var(--blue)", height:"50%"}}/>
      </>
    )
  }

  export const Check = () => {
    return (
      <img src={check} />
    )
  }
  
